import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import PromoDetailModal from 'JS/components/PromoDetailModal.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import { computed, ref } from 'vue';
import { IPDPPromoOfferJson } from 'JS/types/PDP';
import { PDPRootState } from 'JS/pdp/state/types';
import { useLegacyVuexStore } from 'JS/composables/legacy-vuex-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPromos',
  setup(__props) {

const store = useLegacyVuexStore<PDPRootState>();
const bottomExpanded = ref(false);
const promoDetails = ref<IPDPPromoOfferJson | null>(null);

const promosToDisplay = computed(()=> {
	const allPromos = store?.state?.product?.promos ?? [];
	const displayPromos = allPromos.filter(promo => promo.promoType != 6 && promo.promoType != 13);

	return {
		first: displayPromos[0] ?? null,
		others:	displayPromos.slice(1),
	};
});

const promoHeadline = computed(() => {
	if (promoDetails.value.offerTitle && promoDetails.value.pdpText) {
		return promoDetails.value.offerTitle;
	} else if (promoDetails.value.isRewardsOffer) {
		return "Blain's Rewards Offer";
	} else {
		return null;
	}
});

const promoDescription = computed(() => {
	if (!promoDetails.value.pdpText && promoDetails.value.offerTitle) {
		return promoDetails.value.offerTitle;
	} else if (promoDetails.value.pdpText) {
		return promoDetails.value.pdpText;
	} else {
		return null;
	}
});


return { __sfc: true,store, bottomExpanded, promoDetails, promosToDisplay, promoHeadline, promoDescription, Icon, LinkButton, PromoDetailModal, TransitionExpand }
}

})